import { Component, OnInit, OnChanges, SimpleChange, SimpleChanges, Input, AfterViewInit, Pipe, PipeTransform, HostListener, ViewChild, TemplateRef, OnDestroy } from '@angular/core';
import { Globals } from '../objects/Globals';
import { CookieService } from 'ngx-cookie-service';
import { HeaderService } from '../services/header.service';
import { Session, AppSession } from '../objects/Session';
import { LoginService } from '../services/login.service';
import { Action, GroupAction, ValueSelection } from '../objects/DetailObject';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { trigger,state,style,animate,transition } from '@angular/animations';
import { TokenManager } from '../Globals';
import { TimeZoneObject, NotificationObject } from '../objects/HeaderObjects';
import { SlicePipe, DatePipe } from '@angular/common';
import { ToasterService, Toast, BodyOutputType } from 'angular2-toaster';
import { NgProgress, NgProgressRef } from '@ngx-progressbar/core';
import { ToasterMessageService } from '../services/toaster-message.service';
import { ThemeSettingService } from '../services/theme-setting.service';
import { Toaster } from '../objects/ToasterObject';
import { ngxLoadingAnimationTypes } from 'ngx-loading';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { DetailPopupComponent } from '../detail-popup/detail-popup.component';
import { Observable, Subscription } from 'rxjs';
import { MainLoadingService } from '../services/main-loading.service';
import { EnvService } from '../env.service';
import { ModalControlService } from '../services/modal-control.service';
import { DomSanitizer } from '@angular/platform-browser';
import { SessionTimerService } from '../services/session-timer.service';
import { AttachmentService } from '../services/attachment.service';
import { WorkflowReturnService } from '../services/workflow-return.service';
import { IPageInfo } from 'ngx-virtual-scroller';
import introJs from 'intro.js/intro.js';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  animations: [
    trigger('collapse', [
      state('open', style({
        opacity: '1',
        display: 'block',
        transform: 'translate3d(0, 0, 0)'
      })),
      state('closed', style({
        opacity: '0',
        display: 'none',
        transform: 'translate3d(0, -100%, 0)'
      })),
      transition('closed => open', animate('200ms ease-in')),
      transition('open => closed', animate('1ms'))
    ])
  ]
})

export class HeaderComponent implements OnInit, AfterViewInit, OnDestroy {

  private session:Session;
  private cardId:string;
  private userName: string;
  private groupList:GroupAction[] = [];
  private navbarOpen = false;
  private loginNavbarOpen = false;
  private timeZoneList:TimeZoneObject[];
  private timeZoneName: string;
  private selectedTimeZone:string;
  collapse:string = "closed";
  private isBusy: boolean = false;
  private getDate: boolean = false;
  private datePipe: string;
  private currentMenu : string;
  private toasterService: ToasterService;
  private isHomeClicked : boolean = false;
  private toggleTray:boolean = false;
  private toasters:Toaster[];
  private notifications:NotificationObject[] = [];
  private hasNotification:boolean = false;
  private notificationCount:number=0;
  private hasNewNotifications: boolean = false;
  private loaderConfig:any;
  private modalRef: BsModalRef;
  private displayMenu:boolean = true;
  private hasSession:boolean = false;
  private subClock:Subscription;
  private subSyncTime:Subscription;
  private loggedIn: Subscription;
  private subHeaderMenu: Subscription;
  private subRouter: Subscription;
  private currentSessionId:string;
  private portalTitle:string;
  private communityList: ValueSelection[] = [];
  private menuActionId: string;
  private languageCardId: string;
  private menuActions:Action[] = [];
  private languageList: ValueSelection[] = [];
  private currentCommunityId: string;
  allowRegistration:string;
  allowContactUs:string;
  userGuide: string;
  userGuidesHtml: string;
  startPage: boolean = false;
  currentCommunity: string;
  currentLanguage: string;
  currentLanguageDisplay: string;
  progressRef: NgProgressRef;
  downloadUrl:any;
  isFetching: boolean = false;
  lastPageNotification: boolean = false;
  shortHeader: boolean = false;
  headersOrder: string[] = [];

  @ViewChild('trayicon') public trayicon;
  @ViewChild('tray') public tray;

  constructor(private tokenManager:TokenManager, 
    public progress:NgProgress, 
    public globals:Globals, 
    private headerService:HeaderService, 
    private loginService:LoginService,
    private router:Router,
    private route: ActivatedRoute,
    toasterService: ToasterService,
    private toasterMessageService :ToasterMessageService,
    private themeSettingService: ThemeSettingService,
    private modalService:BsModalService,
    private mainLoadingService: MainLoadingService,
    private env: EnvService,
    private modalControlService: ModalControlService,
    private sanitizer: DomSanitizer,
    private sessionTimerService: SessionTimerService,
    private attachmentService: AttachmentService,
    private workflowReturnService: WorkflowReturnService) {
      this.allowRegistration = this.env.allowRegistration;
      this.portalTitle = this.env.portalTitle;
      this.allowContactUs = this.env.allowContactUs;
      this.userGuide = this.env.allowSupplierApplication;
      this.userGuidesHtml = this.env.userGuidesHtml;
      this.shortHeader = this.env.shortHeader;
      this.headersOrder = this.env.headersOrder;

      document.addEventListener('click', this.offClickHandler.bind(this))
      this.toasterService = toasterService;
      this.router.routeReuseStrategy.shouldReuseRoute = function(){
        return false;
      } 

      this.loggedIn = loginService.loggedIn$.subscribe(session=> {
        if (session){
          this.getRequiredInfo(session);
          if (this.subClock){
            if (this.subClock.closed){
              let timer = Observable.timer(1000, 1000);
              this.subClock = timer.subscribe(t => this.UpdateClock());
            }
          }
          if (this.subSyncTime){
            if (this.subSyncTime.closed){
              let timer = Observable.timer(1000, 10000);
              this.subSyncTime = timer.subscribe(t => this.SyncTimeWithServer());
            }
          }
        }
        else{
          if (this.subClock){
            this.subClock.unsubscribe();
          }
          if (this.subSyncTime){
            this.subSyncTime.unsubscribe();
          }
          this.notificationCount = 0;
        }
      });

      this.subHeaderMenu = headerService.headerMenuChanged$.subscribe(displayMenu=> {
        this.displayMenu = displayMenu;
      });

      this.subRouter = router.events.subscribe((val) => {
        if (router.url.indexOf("/khamis/start") > -1 || router.url.indexOf("/home") > -1){
          this.startPage = true;
        }
        else{
          this.startPage = false;
        }
      });
   }

   offClickHandler(event:any) {
     if (this.tray){
      if (!this.trayicon.nativeElement.contains(event.target)) { // check click origin
        if (!this.tray.nativeElement.contains(event.target)){
          this.toggleTray = false;
        }
      }
     }
    
  }

   @HostListener('window:resize', ['$event'])
   onResize(event) {
     if (event.target.innerWidth < 992) {
        this.navbarOpen = false;
     }
   }

  changeTheme(color:any, accentColor: any, secColor:any){
    document.body.style.setProperty('--primary', color);
    document.body.style.setProperty('--accent', accentColor);
    document.body.style.setProperty('--secondary', secColor ? secColor : '#edf7fd');

    this.themeSettingService.setTheme({
      animationType: ngxLoadingAnimationTypes.threeBounce, 
      backdropBackgroundColour: 'rgba(255, 255, 255,0.2)',
      backdropBorderRadius: '10px',
      primaryColour: color, 
      secondaryColour: color,
      tertiaryColour: color, 
      accentColour: accentColor
    });
  }

  ngOnInit() {
    this.progressRef = this.progress.ref('progressBar');
    this.currentMenu = null;
    this.loaderConfig = this.themeSettingService.getTheme();
  }

  ngAfterViewInit(){
  }

  ngOnDestroy(){
    if (this.subClock) this.subClock.unsubscribe();
    if (this.subSyncTime) this.subSyncTime.unsubscribe();
    if (this.loggedIn) this.loggedIn.unsubscribe();
    if (this.subRouter) this.subRouter.unsubscribe();
    if (this.subHeaderMenu) this.subHeaderMenu.unsubscribe();
  }

  getRequiredInfo(session: AppSession){
    if (this.globals.Session){
      if (this.globals.Session.Session.SessionId != this.currentSessionId){
        this.menuActionId = "";
        this.notifications = [];
        this.hasNotification = false;
        this.showCompanyLogo = true;
        this.getUnreadCount();
        this.getLanguages();
        if (this.communityList.length == 0){}
        this.headerService.getUserCommunities().subscribe(result => {
          this.communityList = JSON.parse(result);
          if (this.communityList.length > 0){
            this.communityList.find(x => x.SelectionValue == this.globals.Session.Session.CommunityId).IsSelected = true;
            this.currentCommunityId = this.communityList.find(x => x.SelectionValue == this.globals.Session.Session.CommunityId).SelectionValue;
            this.currentCommunity = this.communityList.find(x => x.SelectionValue == this.globals.Session.Session.CommunityId).SelectionDisplay;
          }
        })
      }
      this.currentSessionId = this.globals.Session.Session.SessionId;
    }
  }

  _checkPath(){

  }

  getMenuActions(){
    if (!this.menuActionId){
      var groupName = "MyMenu";
      this.headerService.createMenuCard(groupName).subscribe(id => {
        this.menuActionId = id;
        this.headerService.getMenuCardMenuActions(this.menuActionId).subscribe(result => {
          if (result){
            var actionsGroup = JSON.parse(result);
            if (actionsGroup[0]){
              this.menuActions = actionsGroup[0].Actions;
            }
          }
        })
      })
    }
  }

  selectMenuAction(actionCommand: string){
    this.mainLoadingService.setLoading(true);
    document.querySelectorAll(".backdrop").item(0).classList.add("main");
    this.headerService.selectMenuCardMenuAction(this.menuActionId, actionCommand).subscribe(result => {
      this.mainLoadingService.setLoading(false);
      this.handleWorkflowReturn(result);
    }, error => {
      this.mainLoadingService.setLoading(false);
    })
  }

  changeCommunity(community: ValueSelection){
    this.headerService.changeCommunity(community.SelectionValue).subscribe(result => {
      if (result){
        if (result == "1"){
          this.showCompanyLogo = true;
          this.currentCommunityId = community.SelectionValue;
          this.currentCommunity = community.SelectionDisplay;
          //get new session and redirect to home
          var sessionCookie = JSON.parse(this.tokenManager.retrieve("BRNSessionKey"));
          this.loginService.getSession(sessionCookie).subscribe(result => {
            this.redirectHome(JSON.parse(result));
          });
        }
      }
    })
  }

  redirectHome(result:any){
    this.globals.CardItems = [];
    this.globals.Session.Session = result.SessionObject.Session;
    this.loginService.setSession(result);
    this.router.navigate(['/', 'home']);
    document.querySelectorAll('.body-content').item(0).classList.remove('mb-login');
    document.querySelectorAll(".body-content").item(0).classList.remove('default');
    document.querySelectorAll('.navbar').item(0).classList.remove('mb-login');
    this.tokenManager.delete("BRNCurrentMenu");
    if (this.globals.Session.Session.SessionId != null) {
      this.tokenManager.store('BRNSessionKey', this.globals.Session.Session.SessionId);
    }
    // this.toasterService.clear();
  }

  ngAfterViewChecked() {
    if (this.globals.Session){
      this.getTimeZoneList();
    }
  }

  getTime() {
    if (!this.getDate) {
      if (this.globals.Session){
        this.getDate = true;
        this.headerService.getTime().subscribe(result=>{
          let slicedValue = new SlicePipe().transform(result, 6, -2);
          this.datePipe = new DatePipe("en-US").transform(new Date(parseInt(slicedValue)), 'dd MMM yyyy hh:mm:ss a');
  
          let clockTimer = Observable.timer(1000, 1000);
          this.subClock = clockTimer.subscribe(t => this.UpdateClock());
         
          let syncTime = Observable.timer(1000, 10000);
          this.SyncTimeWithServer()
          this.subSyncTime = syncTime.subscribe(t => this.SyncTimeWithServer());

          })
      }
    }
  }

  goToDashboard(){
    this.router.navigate(['/']);
    this.tokenManager.store("BRNCurrentRoute", "/");
  }

  UpdateClock() {
    if (this.globals.Session) {
      var date:Date = new Date(this.datePipe);
      var incre:any = date.setSeconds(date.getSeconds() + 1);
      this.headerService.setCurrentUserDateTime(new Date(parseInt(incre)))
      this.datePipe = new DatePipe("en-US").transform(new Date(parseInt(incre)), 'dd MMM yyyy hh:mm:ss a');
    }
  }

  SyncTimeWithServer(){
    if (this.globals.Session){
      this.headerService.getTime().subscribe(result=>{
        let slicedValue = new SlicePipe().transform(result, 6, -2);
        this.headerService.setCurrentUserDateTime(new Date(parseInt(slicedValue)))
        this.datePipe = new DatePipe("en-US").transform(new Date(parseInt(slicedValue)), 'dd MMM yyyy hh:mm:ss a');
      },
      error => {
        this.handleError(error);
      });

      // checkNotifications too every 10 seconds
      this.checkNotifications();
    }
  }

  checkNotifications(){

    //new notifications card
    if (this.notifications.length > 0){
      this.getUnreadCount();
      this.headerService.getLatestNotificationDate().subscribe(result => {
        if (result == "1"){
          this.headerService.getNotifications().subscribe(notification => {
            this.lastPageNotification = false;
            this.notifications = JSON.parse(notification);
            
            this.notifications.forEach(notification => {
              if (notification.IsForcePrompt && !notification.IsRead){
                this.toasterMessageService.popToast(notification.NotificationTitle, notification.NotificationMessage, notification.NotificationType);
                this.headerService.MarkOneNotificationAsRead(notification.NotificationId).subscribe(result => {
                  // thanks
                })
              }
            });
            this.markAsRead();
          });
        }
      }) 
    }
    else{
      this.headerService.getNotifications().subscribe(notification => {
        this.lastPageNotification = false;
        this.notifications = JSON.parse(notification);
        this.markAsRead();
      });
    }
  }

  private getUnreadCount(){
    this.headerService.getUnreadCount().subscribe(result=>{
      var count = parseInt(result);

      this.notificationCount = count;
      if(count > 0){
        this.hasNotification = true;
      }else{
        this.hasNotification = false;
      }
    },
    error => {
      this.handleError(error);
    });
  }

  sortNotifications(notifications:NotificationObject[]){
    this.notifications = notifications.sort((a:NotificationObject,b:NotificationObject) => { 
      if(a.NotificationDate < b.NotificationDate){
        return 1;
      }else if(a.NotificationDate > b.NotificationDate){
        return -1;
      }else{
        return 0;
      }
    });
  }

  updateProfile(){
    this.mainLoadingService.setLoading(true);
    this.headerService.updateProfile().subscribe(result => {
      this.mainLoadingService.setLoading(false);
      this.handleWorkflowReturn(result);
    });
  }

  changePassword(){
    this.mainLoadingService.setLoading(true);
    this.headerService.changePassword().subscribe(result => {
      this.mainLoadingService.setLoading(false);
      this.handleWorkflowReturn(result);
    });
  }

  goToHome(){
    if (!this.startPage){
      this.tokenManager.store("BRNCurrentMenu", "Home");
      this.mainLoadingService.setProgressBar(true);
      // this.progressRef.start();
      this.loginService.getHomePage().subscribe(result=>{
        this.mainLoadingService.setProgressBar(false);
        var command = JSON.parse(result);
        this.workflowReturnService.handleWorkflowReturn(command, true, true);
      }, error => {
        this.progressRef.complete();
      });
    }
  }

  toggleNavbar() {
    this.navbarOpen = !this.navbarOpen;
  }

  toggleLoginNavbar() {
    this.loginNavbarOpen = !this.loginNavbarOpen;
  }

  logOutSession():void{
    this.mainLoadingService.setLoading(true);
    this.headerService.setSessionAlive(false);
    this.sessionTimerService.stopSessionTimer();
    this.headerService.endSession().subscribe(result => {
      if (result == "1"){
        this.popToast("Info", "Your session has ended", "info");
      }
      this.mainLoadingService.setLoading(false);
      this.clear();
      this.router.navigate(['/login']);
    }, error => {
      this.mainLoadingService.setLoading(false);
      this.popToast("Error", "Unable to process action", "error");
    });
  }

  clear(){
    this.globals.Session = null;
    this.tokenManager.clear();
    this.menuActions = [];
    this.currentMenu = null;
    this.loginNavbarOpen = false;
    this.navbarOpen = false;
    this.progressRef.complete();
    this.toggleTray = false;
    this.notifications = [];
    this.toasterMessageService.clearToaster();
    this.mainLoadingService.setProgressBar(false);
    this.loginService.setSession(null);
  }

  handleError(error: any){
    if (error.status == 0){ // no response
      this.loginService.setSession(null);
    }
  }

  popToast(title: string, body: string, type: string) {
    var toast: Toast = {
      type: type,
      title: title,
      body: body,
      showCloseButton: true,
      bodyOutputType: BodyOutputType.TrustedHtml,
      onShowCallback: (toast) => 
      {
        var toaster = new Toaster();
        toaster.id = toast.toastId;
        toaster.timestamp = Date.now();
        toaster.title = toast.title;
        toaster.content = toast.body;
        this.toasterMessageService.pushToaster(toaster);
      }
    };
    this.toasterService.pop(toast);
  }

  getTimeZoneList(){
    if(this.timeZoneList == null && !this.isBusy){
      this.isBusy = true;
      this.headerService.getTimeZoneList().subscribe(result=>{
        this.timeZoneList = JSON.parse(result);
        this.timeZoneList.forEach(obj => {
          if (obj.Id == this.globals.Session.Session.TimeZoneSetting){
            this.timeZoneName = obj.Id;
          }
        });

        if(this.timeZoneName == null) {
          this.timeZoneName = this.timeZoneList[0].TimeZoneName;
        }
        this.getTime();
      });
    }
  }

  onTimeZoneChange(event){
    this.headerService.setTimeZone(event).subscribe(result => {
      if(result == "1"){
        this.popToast("Timezone updated","Please re login to see the change", "warning");
      }
    });
  }

  getLanguages(){
    this.headerService.createLanguageCard().subscribe(id => {
      if (id){
        this.languageCardId = id;
        this.headerService.getLanguages(id).subscribe(result => {
          this.languageList = JSON.parse(result);
          this.currentLanguage = this.languageList.find(x => x.SelectionValue == this.globals.Session.Session.LanguageSetting).SelectionValue;
          this.currentLanguageDisplay = this.languageList.find(x => x.SelectionValue == this.globals.Session.Session.LanguageSetting).SelectionDisplay;
        })
      }
    })
  }

  selectLanguage(locale: string){
    this.mainLoadingService.setLoading(true);
    this.headerService.selectLanguage(this.languageCardId, locale).subscribe(result => {
      this.mainLoadingService.setLoading(false);
      this.handleWorkflowReturn(result);
    }, error => {
      this.mainLoadingService.setLoading(false);
    })
  }

  showNotification(){
    this.toggleTray = !this.toggleTray;
    
    if (this.toggleTray){
      this.headerService.getNotifications().subscribe(notification => {
        this.lastPageNotification = false;
        this.notifications = JSON.parse(notification);
        this.markAsRead();
      });
    }
    
    // toasters from angular
    var items:Toaster[] = this.toasterMessageService.getToaster();
    this.toasters = items.sort(this.sortToaster);
  }

  markAsRead(){
    if (this.toggleTray){ // true means opened

      this.notifications.forEach(noti => {
        noti.IsRead = true;
      });
      this.notificationCount = 0;
      this.headerService.markNotificationsRead().subscribe(result=>{
        if (result == "1") {
          setTimeout(() => {
            // wont call a new one to get new notifications, because it should already be the latest, once there's new notifications it will call this if opened
            // so in this case, current notifications will be changed to read
            this.getUnreadCount();
          })
        }
      });
    }
  }

  selectNotification(id:string){
    this.mainLoadingService.setLoading(true);
    this.headerService.selectNotification(id).subscribe(result=>{
      if(result){
        this.handleWorkflowReturn(result);
        this.toggleTray = false;
      }
      else{
        this.mainLoadingService.setLoading(false);
      }
    }, error => {
      this.mainLoadingService.setLoading(false);
    });
  }

  sortToaster(a,b) {
    if (a.timestamp > b.timestamp)
      return -1;
    if (a.timestamp < b.timestamp)
      return 1;
    return 0;
  }

  fetchMore(event: IPageInfo) {
    if (this.lastPageNotification) return;
    if (event.endIndex == this.notifications.length - 1){
      if (!this.isFetching) {
          this.isFetching = true;
          this.fetchNextChunk(this.notifications.length, 10).then(chunk => {
            if(chunk.length == this.notifications.length) this.lastPageNotification = true;
            this.notifications = chunk;
            this.isFetching = false;
          }, () => this.isFetching = false);
      }
    };
  }

  fetchNextChunk(skip: number, limit: number): Promise<any[]> {
    return new Promise((resolve, reject) => {

      this.headerService.notificationsNextPage().subscribe(result => {
        if (result == "1"){
          this.headerService.getNotifications().subscribe(notifications => {
            var newNotifications = JSON.parse(notifications);
            resolve(newNotifications);
          })
        }
      })
    });
  }

  startTour(){
    
    // var intro:any = introJs.introJs();
    // intro.setOptions({
    //   steps: [
        
        // {
        //   element: '#GoToQP_link',
        //   intro: 'Click this menu to see the quick phrase page',
        //   position: 'right'
        // },
        // {
        //   element: '#GoToPG_link',
        //   intro: 'Click this menu to get to product management page',
        //   position: 'right'
        // },
        // {
        //   element: '#DBPending-M_AttentionItems',
        //   intro: 'This is the attention items'
        // },
        // {
        //   element: "#card-pending-0",
        //   intro: 'Open tender',
        //   position: 'left'
        // },
        // {
        //   element: '#search',
        //   intro: 'Global search',
        //   position: 'bottom'
        // }
        
    //   ],
    //   showBullets: true,
    //   showButtons: true,
    //   exitOnOverlayClick: false,
    //   showStepNumbers: false,
    //   keyboardNavigation: true,
    //   overlayOpacity: 0.8,
    //   doneLabel: 'X',
    //   skipLabel: 'X',
    //   highlightClass: "helper-layer"
    // });
    // intro.start();

    var path = this.router.url;
    this.headerService.getPageTour(path).subscribe(steps => {
      var bigSteps = JSON.parse(steps);
      
      
      if (steps){
        // bigSteps.forEach(step => {
        //   console.log(step.element);
        //   var matches = step.element.match(/\{(.*?)\}/g);
        //   console.log(matches);
        //   if (matches){
        //     matches.forEach(match => {
        //       var className = match.split('|')[0].replace('{', '').replace('}','');
        //       var order = match.split('|')[1];
        //       step.element = step.element.replace(match.split('|')[0], document.querySelectorAll(className)[0] as HTMLElement);
        //       console.log(step.element);
        //       console.log(step);
        //     });
        //   }
         
        // });
        // console.log(bigSteps);
        var intro:any = introJs();
        intro.setOptions({
          steps: bigSteps,
          showBullets: true,
          showButtons: true,
          exitOnOverlayClick: true,
          showStepNumbers: false,
          keyboardNavigation: true,
          overlayOpacity: 0.7,
          doneLabel: 'X',
          skipLabel: 'X',
          highlightClass: "helper-layer"
        });
        intro.start();
      }
    })
    
  }

  handleWorkflowReturn(result: any): any {
    var command = JSON.parse(result);

    if (command.ReturnType == 7){ //download file
      this.attachmentService.downloadFile(command.Arguments[0]).subscribe(data=>{
        this.workflowReturnService.downloadFile(data, command.Arguments[1]);
        this.mainLoadingService.setLoading(false);
      }, error => {
        this.mainLoadingService.setLoading(false);
      });
    }
    else{
      this.workflowReturnService.handleWorkflowReturn(command);
      this.mainLoadingService.setLoading(false);
    }

      // switch(command.ReturnType){
      //   case 0: // navigate
      //     if(command.Arguments){
      //       var path = [];
      //       command.Arguments.forEach(element => {
      //         path.push(element);
      //       });
      //       this.router.navigate(path);
      //     }
      //     break;
      //   case 1: //message
      //     this.toasterMessageService.popToast(command.Arguments[0], command.Arguments[1], command.SubType);
      //     break;
      //   case 2: //reload, does nothing, depends on refreshtype
      //     break;
      //   case 3: //open popup
      //     this.openPopup(command.Arguments[0], command.Arguments[1]);
      //     break;
      //   case 4: //message
      //     var list = ["parent", "all"];
      //     if (list.filter(x => x == command.RefreshType).length == 0){
      //       this.modalService.hide(this.modalService.getModalsCount() - 1);
      //     }
      //     this.toasterMessageService.popToast(command.Arguments[0], command.Arguments[1], command.SubType);
      //     if (command.Arguments[2]){
      //       this.openPopup(command.Arguments[2], "");
      //     }
      //     break;
      //   case 5: //summary popup
      //     this.modalControlService.launchModal(command.Arguments[0], command.Arguments[1], "summary", "modal-summary");
      //     break;
      //   case 6: //comparison
      //     this.modalControlService.launchModal(command.Arguments[0], command.Arguments[1], "compare");
      //     break;
      //   case 7: //download file
      //     this.attachmentService.downloadFile(command.Arguments[0]).subscribe(data=>{
      //       this.downloadFile(data, command.Arguments[1]);
      //     });
      //   break;
      // }
  }

  // downloadFile(blob: any, fileName:string): void {
  //   const objectUrl: string = URL.createObjectURL(blob);
  //   const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;

  //   a.href = objectUrl;
  //   a.download = fileName;
  //   document.body.appendChild(a);
  //   a.click();        

  //   document.body.removeChild(a);
  //   URL.revokeObjectURL(objectUrl);
  // }

  // openPopup(id:string, title: string) {
  //   const config: ModalOptions = {
  //     keyboard: false,
  //     ignoreBackdropClick: true,
  //     class: 'modal-dialog-centered modal-detail',
  //     initialState: {
  //       componentId: id,
  //       title: title
  //     }
  //   };

  //   this.modalRef = this.modalService.show(DetailPopupComponent, config);
  // }
  showCompanyLogo: boolean = true;
  onErrorImage(event){
    this.showCompanyLogo = false;
  }
}
